<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large class="blue--text text--darken-2">
          mdi-settings
        </v-icon>
        <h2 class="display-2 my-2">
          Einstellungen
        </h2>
      </v-col>
    </v-row>

    <v-row
      justify="center"
    >
      <v-col
        cols="10"
        sm="6"
      >
        <v-card>
          <v-list>
            <v-list-group
              v-for="item in settingItems"
              :key="item.title"
              v-model="item.active"
              :prepend-icon="item.action"
              no-action
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <v-list-item
                v-for="subItem in item.items"
                :key="subItem.title"
                :disabled="subItem.disabled"
                :to="subItem.to"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="subItem.action">
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { ROOT_LOADING } from '../../store/mutation-types'

export default {
  name: 'Einstellungen',
  metaInfo: {
    title: 'Einstellungen'
  },
  data () {
    return {
      settingItems: [
        {
          action: 'mdi-settings-outline',
          title: 'Allgemein',
          items: [
            { title: 'Managername ändern', disabled: false, to: '/settings/managername', action: 'mdi-textbox' },
            { title: 'Managerbild ändern', disabled: false, to: '/settings/managerbild', action: 'mdi-account-box-outline' },
            { title: 'Teamname ändern', disabled: false, to: '/settings/teamname', action: 'mdi-textbox' },
            { title: 'Teambild ändern', disabled: false, to: '/settings/teamlogo', action: 'mdi-image-frame' }
          ]
        },
        {
          action: 'mdi-security',
          title: 'Sicherheit',
          items: [
            { title: 'Passwort ändern', disabled: false, to: '/settings/new-password', action: 'mdi-textbox-password' },
            { title: 'E-Mail-Adresse ändern', disabled: false, to: '/settings/new-email', action: 'mdi-email-outline' }
          ]
        },
        {
          action: 'mdi-account',
          title: 'Account',
          items: [
            { title: 'Löschen', disabled: false, to: '/settings/deleteAccount', action: 'mdi-delete-forever-outline' }
          ]
        }
      ]
    }
  },
  created () {

  },
  methods: {

  }
}
</script>
